import {
  Box, TextField,
} from '@mui/material';
import InputMask from 'react-input-mask';
import React, { memo } from 'react';
import { BACKGROUND_LIGHT } from '../../constants/colors';

const innerContainerSx = {
  fieldset: {
    border: 'none',
  },
  '&.error': {
    fieldset: {
      border: ({ palette }) => `1px solid ${palette.error.main}`,
    },
    '& .MuiInputLabel-root': {
      color: ({ palette }) => palette.error.main,
    },
    '& .MuiFormHelperText-root': {
      color: ({ palette }) => palette.error.main,
    },
  },
  '.MuiInputBase-root.MuiInputBase-formControl': {
    borderRadius: '8px',
    background: BACKGROUND_LIGHT,
  },
};

const INN_MASK = '9999999999';

const INN_PLACEHOLDER = '__________';

function InnLegalInput({
  error,
  value,
  disabled,
  containerSx,
  onChange,
  onClickIcon,
  name,
  label = 'ИНН',
  ...rest
}) {
  const errorClass = (!disabled && error) ? 'error' : '';

  return (
    <Box className={errorClass} sx={{ ...innerContainerSx, ...containerSx }}>
      <InputMask
        mask={INN_MASK}
        maskChar="_"
        onChange={(e) => onChange(e, e.target.value)}
        value={value}
        disabled={disabled}
      >
        {() => (
          <Box position="relative" width="100%" display="flex" alignItems="center">
            <TextField
              fullWidth
              type="tel"
              name={name}
              disabled={disabled}
              onKeyEnter={onClickIcon}
              placeholder={INN_PLACEHOLDER}
              label={label}
              error={error || false}
              helperText={error || ''}
              value={value} // if disable this, label broke
              {...rest}
            />
          </Box>
        )}
      </InputMask>
    </Box>
  );
}

export default memo(InnLegalInput);
